// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2bLVw","ranges":"BmiRanges_ranges__3nCoM"};